module.exports = __webpack_public_path__ + "img/upload_bg_05.86c07d60.png";